import _ from 'lodash';
import React, { FunctionComponent, useState } from 'react';
import classNames from 'classnames';
import { ContactFormField } from './types/contactForm';

interface TextInputProps {
  description?: string;
  field: ContactFormField;
  label: string;
  name: string;
  onChange: (event: React.SyntheticEvent<HTMLElement>) => void;
  isTextArea?: boolean;
}

export const TextInput: FunctionComponent<TextInputProps> = ({
  description,
  field,
  label,
  name,
  onChange,
  isTextArea
}: TextInputProps) => {
  const [dirty, setDirty] = useState<boolean>(false);

  const classes = classNames('text-input', name);
  if (isTextArea) {
    classes.concat(' text-area');
  }
  const labelId = `${name}-label`;

  const descriptionElement = description ? (
    <span id="description" className="x-small quiet">
      {description}
    </span>
  ) : null;

  const isInvalid = field.invalid && dirty;

  const inputProps = {
    id: name,
    className: classes,
    type: isTextArea ? undefined : 'text',
    value: field.value,
    'aria-invalid': isInvalid,
    'aria-labelledby': labelId,
    'aria-required': true,
    onChange: onChange,
    onBlur: () => setDirty(true)
  };

  return (
    <div>
      <label id={labelId} htmlFor={name} className="block-label">
        {label}
        {descriptionElement}
      </label>

      {isTextArea ? <textarea {...inputProps} /> : <input {...inputProps} />}
    </div>
  );
};

export default TextInput;
